import { DEV } from 'esm-env';

export function register(path: string) {
  if ('__disable_service_worker__' in window || DEV) {
    return Promise.reject(null);
  }
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.register(path);
  }
  return Promise.reject(new Error('ServiceWorkers are not supported by browser!'));
}
